import { makeStyles } from '@fluentui/react-components';

export const useCustomerUpdatesTableActionStyles = makeStyles({
    action: {
        marginRight: '10px',
    },
    hiddenAction: {
        visibility: 'hidden',
        '@media (max-width: 1300px)': {
            display: 'none',
        },
    },
});
